import axios from 'axios';
import store from '../store';

const apiClient = axios.create({
  baseURL: '/api', // 修改为相对路径，使用代理
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器
apiClient.interceptors.request.use(
  config => {
    const token = store.state.userInfo ? store.state.userInfo.jwtToken : null; // 从 userInfo 中获取 jwtToken
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
apiClient.interceptors.response.use(
  response => {
    // 检查返回的数据格式
    if (response.data.code === '500' && response.data.msg === 'token timeout') {
      // 清除本地存储的用户信息
      localStorage.removeItem('user');
      // 清除 store 中的用户信息
      store.dispatch('logout');
      return Promise.reject(new Error('登录已过期，请重新登录'));
    }
    
    if (response.data.status === 'error') {
      // 统一处理后端返回的错误
      console.error('后端返回错误:', response.data.message);
      return Promise.reject(new Error(response.data.message || '未知错误'));
    }
    return response.data; // 返回实际的数据部分
  },
  error => {
    // 处理 HTTP 错误
    console.error('API 请求错误:', error);
    if (error.response) {
      // 请求已发出，但服务器响应的状态码不在 2xx 范围内
      if (error.response.status === 401 || 
          (error.response.data && error.response.data.code === '500' && error.response.data.msg === 'token timeout')) {
        // 未授权或 token 超时
        localStorage.removeItem('user');
        store.dispatch('logout');
      }
      // 返回一个包含错误信息的Promise
      return Promise.reject(new Error(error.response.data.msg || `请求错误: ${error.response.status}`));
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      return Promise.reject(new Error('无法连接到服务器'));
    } else {
      // 在设置请求时出错
      return Promise.reject(new Error('请求失败: ' + error.message));
    }
  }
);

export default apiClient;

// 获取学生列表
export function getUserList() {
  return apiClient.get('/records/userlist');
}

// 添加点名记录
export function addAttendanceRecord(data) {
  return apiClient.post('/records/addrecord', data);
}

// 获取点名记录列表
export function getRecordsList(keyword = '') {
  let url = '/records/list';
  if (keyword && keyword.trim()) {
    url += `?keyword=${encodeURIComponent(keyword.trim())}`;
  }
  return apiClient.get(url);
}

// 删除点名记录
export function deleteRecord(id) {
  return apiClient.delete(`/records/delete/${id}`);
} 